import { render, staticRenderFns } from "./UserAdminCard.vue?vue&type=template&id=fea18902&scoped=true"
import script from "./UserAdminCard.vue?vue&type=script&lang=js"
export * from "./UserAdminCard.vue?vue&type=script&lang=js"
import style0 from "./UserAdminCard.vue?vue&type=style&index=0&id=fea18902&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../admin/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fea18902",
  null
  
)

export default component.exports